/**
 * Created by james on 3/5/14.
 */
"use strict";

var Adjustment = require("bunsen/models/ecomm/Adjustment");
var SellerAdjustment = module.exports = Adjustment.extend();

var Backbone = require('dibs-backbone');
var SoaModel = require("bunsen/models/SoaModel");
var _ = require('underscore');

/**
 * Empty container model - necessary to reflect the data structure where StateTaxAdjustments will have only 1
 * attribute to "adjustment"
 * @type {*}
 */
var SaleAdjustment = SoaModel.extend({
    defaults: {
        rateType: 'PERCENT'
    },
    relations: [{
        key: 'rate',
        relatedModel: SoaModel,
        type: Backbone.One
    }]
});


/**
 * Defining models of Adjustment collection
 * @property defaults.applyToShipping{string} 'N'
 * @type {*}
 */
_.extend(SellerAdjustment.prototype, {
    defaults: {
        applyToShipping: 'N'
    },
    relations: [{
        key: 'saleAdjustment',
        relatedModel : SaleAdjustment,
        type: Backbone.One
    }]
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/SellerAdjustment.js
// module id = 2039
// module chunks = 62